<template>
  <div class="salesReport">
    <div class="filter">
      <div class="filter_item">
        <el-date-picker
          class="filter_item_times"
          v-model="form.times"
          type="daterange"
          :editable="false"
          :clearable="false"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="datePickerOptions">
        </el-date-picker>
      </div>
      <div class="filter_item">
        <el-select class="filter_item_select" v-model="form.salesType" clearable placeholder="全部动作">
          <el-option label="销售" :value="1"></el-option>
          <el-option label="销售退货" :value="2"></el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <el-select class="filter_item_select" v-model="form.isLoad" clearable placeholder="上报状态">
          <el-option label="待上报" :value="0"></el-option>
          <el-option label="上报失败" :value="2"></el-option>
          <el-option label="已上报" :value="1"></el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <el-select
          class="filter_item_input"
          v-model="form.searchField"
          placeholder="商品名称/货号"
          filterable
          remote
          :remote-method="drugRemote"
          clearable
          :loading="drugMap.loading">
          <el-option
            v-for="item in drugMap.list"
            :key="item.artNo"
            :label="item.drugName"
            :value="item.artNo">
            <div class="drug_option">
              <span class="drug_option_left">{{ item.artNo }}</span>
              <span class="drug_option_right">{{ item.drugName }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="filter_item">
        <el-input
          class="filter_item_input"
          v-model="form.traceCode"
          placeholder="追溯码"
          prefix-icon="el-icon-search"
          clearable>
        </el-input>
      </div>
      <div class="filter_action">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </div>

    <div class="report_last">最近一次上报：{{ countMap.latestUploadTime || '-' }}</div>

    <div class="drug_list">
      <el-table
        :data="list"
        border
        style="width: 100%">
        <el-table-column prop="updateTime" label="动作发生时间" min-width="160">
          <template slot-scope="scope">
            <div class="drug_list_updateTime" @click="viewCode(scope.row)">{{ scope.row.updateTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="setlType" label="结算类型" min-width="100">
          <template slot-scope="scope">
            <div>{{ setlTypeMap[scope.row.setlType] || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="订单" min-width="240"></el-table-column>
        <el-table-column prop="patientName" label="患者姓名" min-width="100"></el-table-column>
        <el-table-column prop="drugName" label="商品名称" min-width="140"></el-table-column>
        <el-table-column prop="batchNo" label="批号" min-width="140"></el-table-column>
        <el-table-column prop="ybCode" label="医保编码" min-width="160"></el-table-column>
        <el-table-column prop="type" label="动作" min-width="80">
          <template slot-scope="scope">
            <div>{{ typeMap[scope.row.type] || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="变更量" min-width="80" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.type == 1 ? '-' : '+' }}{{ scope.row.quantity }}{{ scope.row.unit }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="setlType" label="追溯码" min-width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.needTraCode == 1" :class="scope.row.traCodes.length >= Math.ceil(scope.row.quantity) ? 'code_success' : 'code_error'">{{ scope.row.traCodes.length }}/{{ Math.ceil(scope.row.quantity) }}</div>
            <div v-if="scope.row.needTraCode == 2" class="drug_list_noNeed">无需采集</div>
          </template>
        </el-table-column>
        <el-table-column prop="loadTime" label="上报时间" min-width="160"></el-table-column>
        <el-table-column prop="isLoad" label="上报状态" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isLoad == '0'" type="warning">待上报</el-tag>
            <el-tag v-if="scope.row.isLoad == '1'" type="success">已上报</el-tag>
            <el-tag v-if="scope.row.isLoad == '2'" type="danger">上报失败</el-tag>
            <el-tag v-if="scope.row.isLoad == '3'">待采集</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="drug_footer">
      <el-pagination
        :current-page="form.pageNo"
        :page-size="form.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="listPageNoChange">
      </el-pagination>
      <div class="drug_count">共<b>{{ countMap.totalCount }}</b>条数据，成功<b>{{ countMap.successCount }}</b>条，失败<b>{{ countMap.failCount }}</b>条，待上报<b>{{ countMap.waitUploadCount }}</b>条</div>
    </div>

    <el-dialog
      title="追溯码全链路"
      class="code_dialog"
      :visible.sync="codeMap.visible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="code_content">
        <div class="code_basic">
          <div class="code_basic_item">
            <div>商品名称：</div>
            <div>{{ codeMap.drugName }}</div>
          </div>
          <div class="code_basic_item">
            <div>动作：</div>
            <div>{{ typeMap[codeMap.type] || '-' }}</div>
          </div>
          <div class="code_basic_item">
            <div>变更量：</div>
            <div>{{ codeMap.type == 1 ? '-' : '+' }}{{ codeMap.quantity }}{{ codeMap.unit }}</div>
          </div>
          <div class="code_basic_item">
            <div>商品货号：</div>
            <div>{{ codeMap.hh }}</div>
          </div>
          <div class="code_basic_item">
            <div>批号：</div>
            <div>{{ codeMap.batchNo }}</div>
          </div>
          <div class="code_basic_item">
            <div>结算类型：</div>
            <div>{{ setlTypeMap[codeMap.setlType] || '-' }}</div>
          </div>
          <div class="code_basic_item">
            <div>上报状态：</div>
            <div>
              <template v-if="codeMap.isLoad == '0'">待上报</template>
              <template v-if="codeMap.isLoad == '1'">已上报</template>
              <template v-if="codeMap.isLoad == '2'">上报失败</template>
            </div>
          </div>
          <div class="code_basic_item">
            <div>医保编码：</div>
            <div>{{ codeMap.ybCode }}</div>
          </div>
          <div class="code_basic_item">
            <div>患者：</div>
            <div>{{ codeMap.patientName }}</div>
          </div>
          <div class="code_basic_item">
            <div>上报时间：</div>
            <div>{{ codeMap.loadTime || '-' }}</div>
          </div>
        </div>
        <div v-if="codeMap.needTraCode == 2" class="code_noNeed">无需采集</div>
        <div v-if="codeMap.needTraCode == 1" class="code_info">
          <div class="code_info_title">
            <span>追溯码</span>
            <span :class="`code_info_title_count ${codeMap.traCodes.length >= Math.ceil(codeMap.quantity) ? 'code_success' : 'code_error'}`">{{ codeMap.traCodes.length }}/{{ Math.ceil(codeMap.quantity) }}</span>
          </div>
          <el-table
            class="code_info_table"
            :data="codeMap.traCodes"
            height="300"
            border>
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="traCode" label="追溯码" min-width="160"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'salesReport',
    data() {
      return {
        setlTypeMap: {
          1: '非医保',
          2: '市医保',
          3: '省医保'
        },
        typeMap: {
          1: '销售',
          2: '销售退货'
        },
        firstSelectedDate: null,
        drugMap: {
          loading: false,
          list: []
        },
        listLoading: false,
        form: {
          times: [],
          salesType: '',
          isLoad: '',
          searchField: '',
          traceCode: '',
          pageNo: 1,
          pageSize: 10
        },
        list: [],
        total: 0,
        countMap: {
          latestUploadTime: '',
          totalCount: 0,
          successCount: 0,
          failCount: 0,
          waitUploadCount: 0
        },
        codeMap: {
          visible: false,
          drugName: '',
          type: '',
          quantity: '',
          unit: '',
          hh: '',
          batchNo: '',
          setlType: '',
          isLoad: '',
          ybCode: '',
          patientName: '',
          loadTime: '',
          needTraCode: '',
          traCodes: []
        }
      }
    },
    computed: {
      datePickerOptions () {
        return {
          disabledDate: (date) => {
            if (!this.firstSelectedDate) return false
            const startDate = new Date(this.firstSelectedDate)
            const minDate = new Date(startDate)
            minDate.setFullYear(minDate.getFullYear() - 1)
            const maxDate = new Date(startDate)
            maxDate.setFullYear(maxDate.getFullYear() + 1)
            return date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime()
          },
          onPick: ({ maxDate, minDate }) => {
            if (!maxDate && minDate) {
              this.firstSelectedDate = minDate
            } else {
              this.firstSelectedDate = null
            }
          }
        }
      }
    },
    created () {
      this.form.times = this.getMonthRange()
      this.getCount()
      this.getList()
    },
    methods: {
      getMonthRange () {
        const now = new Date()
        const pad = (n) => String(n).padStart(2, '0')
        const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
        const start = new Date(now.getFullYear(), now.getMonth(), 1)
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
        return [fmt(start), fmt(end)]
      },
      async drugRemote (query) {
        if ([null, undefined, ''].includes(query)) {
          this.drugMap.list = []
          return
        }
        this.drugMap.loading = true
        const res = await req.get('/system/use/queryDrugInfo', {
          deptId: sessionStorage.getItem('deptId'),
          searchWhere: query,
          pageNo: 1,
          pageSize: 20
        })
        this.drugMap.loading = false
        if (res.code === 200) {
          this.drugMap.list = res.data.list
        }
      },
      async getCount () {
        const res = await req.post('/midd/officeDrug/queryUploadDataSummary', {
          startTime: this.form.times && this.form.times.length > 0 ? this.form.times[0] + ' 00:00:00' : '',
          endTime: this.form.times && this.form.times.length > 0 ? this.form.times[1] + ' 23:59:59' : '',
          salesType: this.form.salesType,
          isLoad: this.form.isLoad,
          searchField: this.form.searchField,
          traceCode: this.form.traceCode
        })
        if (res.code === 200) {
          this.countMap.latestUploadTime = res.data.latestUploadTime || ''
          this.countMap.totalCount = res.data.totalCount || 0
          this.countMap.successCount = res.data.successCount || 0
          this.countMap.failCount = res.data.failCount || 0
          this.countMap.waitUploadCount = res.data.waitUploadCount || 0
        }
      },
      async getList () {
        this.listLoading = true
        const res = await req.post('/midd/officeDrug/queryUploadDataPage', {
          startTime: this.form.times && this.form.times.length > 0 ? this.form.times[0] + ' 00:00:00' : '',
          endTime: this.form.times && this.form.times.length > 0 ? this.form.times[1] + ' 23:59:59' : '',
          salesType: this.form.salesType,
          isLoad: this.form.isLoad,
          searchField: this.form.searchField,
          traceCode: this.form.traceCode,
          pageNum: this.form.pageNo,
          pageSize: this.form.pageSize
        })
        this.listLoading = false
        if (res.code === 200) {
          this.list = res.rows.map(v => {
            v.traCodes = v.traCodes ? v.traCodes.split(',') : []
            v.quantity = Math.abs(v.quantity)
            return v
          }) || []
          this.total = res.total
        }
      },
      listPageNoChange (pageNo) {
        this.form.pageNo = pageNo
        this.getList()
      },
      async search () {
        this.form.pageNo = 1
        this.getCount()
        this.getList()
      },
      async reset () {
        this.firstSelectedDate = null
        this.form = {
          times: this.getMonthRange(),
          salesType: '',
          isLoad: '',
          searchField: '',
          traceCode: '',
          pageNo: 1,
          pageSize: 10
        }
        this.getCount()
        this.getList()
      },
      viewCode (row) {
        this.codeMap.drugName = row.drugName || '-'
        this.codeMap.type = row.type || ''
        this.codeMap.quantity = row.quantity || ''
        this.codeMap.unit = row.unit || ''
        this.codeMap.hh = row.hh || ''
        this.codeMap.batchNo = row.batchNo || ''
        this.codeMap.setlType = row.setlType || ''
        this.codeMap.isLoad = row.isLoad || ''
        this.codeMap.ybCode = row.ybCode || ''
        this.codeMap.patientName = row.patientName || ''
        this.codeMap.loadTime = row.loadTime || ''
        this.codeMap.needTraCode = row.needTraCode || ''
        this.codeMap.traCodes = row.traCodes && row.traCodes.map(v => { return { traCode: v } }) || []
        this.codeMap.visible = true
      }
    }
  }
</script>

<style lang="less" scoped>
  .salesReport {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  .filter_item {
    
  }

  .filter_item_times {
    width: 230px;
  }

  .filter_item_select {
    width: 120px;
  }

  .filter_item_input {
    width: 220px;
  }

  .drug_option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 220px;
  }

  .drug_option_left {
    flex-shrink: 0;
    width: 60px;
  }

  .drug_option_right {
    flex-grow: 1;
    margin: 0 0 0 12px;
    min-width: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .report_last {
    margin: 24px 0 0 0;
    width: 100%;
    font-size: 14px;
    color: #666666;
  }

  .drug_list {
    margin: 24px 0 0 0;
    width: 100%;
  }

  .drug_list_updateTime {
    color: #409EFF;
    cursor: pointer;
  }

  .code_success {
    color: #67c23a;
  }

  .code_error {
    color: #f56c6c;
  }

  .drug_list_noNeed {
    color: #666666;
  }

  .drug_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .drug_count {
    font-size: 14px;
    color: #666666;
  }

  .drug_count b {
    margin: 0 4px;
    color: #000000;
  }

  .code_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .code_content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .code_basic {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    padding: 12px;
    width: 100%;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
  }

  .code_basic_item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .code_basic_item>div:nth-child(1) {
    flex-shrink: 0;
  }

  .code_noNeed {
    margin: 24px 0 0 0;
    font-size: 14px;
    color: #666666;
  }

  .code_info {
    margin: 24px 0 0 0;
    width: 100%;
  }
  
  .code_info_title {
    font-size: 14px;
    color: #000000;
  }

  .code_info_title_count {
    margin: 0 0 0 6px;
    font-size: 14px;
  }

  .code_info_table {
    margin: 12px 0 0 0;
    width: 100%;
  }
</style>
